import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import JurusanService from "../../services/JurusanService";
import {getDataPekerjaan} from "./pekerjaanSlice";

export const initialState = {
    loading: false,
    dataJurusan: [],
    showMessage:false,
    message:''
}


export const getDataJurusan = createAsyncThunk('ref/pekerjaan',async (data, { rejectWithValue }) => {
    try {
        const response = await JurusanService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const jurusanSlice = createSlice({
    name: 'jurusan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataJurusan.fulfilled, (state, action) => {
                state.loading = false
                state.dataJurusan = action.payload
            })
            .addCase(getDataJurusan.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataJurusan.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataJurusan = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = jurusanSlice.actions

export default jurusanSlice.reducer
